import { defineStore } from 'pinia';

interface LoadingState {
    isLoading: boolean;
    requestCount: number;
}

export const useLoadingStore = defineStore('loading', {
    state: (): LoadingState => ({
        isLoading: false,
        requestCount: 0
    }),
    actions: {
        increment: function(this: any): void {
            this.requestCount++;
            this.isLoading = true;
        },
        decrement: function(this: any): void {
            this.requestCount = Math.max(0, this.requestCount - 1);
            if (this.requestCount === 0) {
                this.isLoading = false;
            }
        },
        show: function(this: any): void {
            this.isLoading = true;
        },
        hide: function(this: any): void {
            this.requestCount = 0;
            this.isLoading = false;
        }
    }
});
